import {
  isValidEmail,
  isValidMobile,
} from 'src/clinic/views/onboardng/clinicBrand/components/utils'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import { removePlusFromBeginning } from 'src/consumer/helpers/utilFunctions'

export function buildPatientDataForSelectingForNewBookingCalendar(selectedPatientData) {
  const toSetSelectedPatientData = {
    ...selectedPatientData,
    age: getAgeFromDobWithTime(selectedPatientData?.dateOfBirth),
  }
  if (
    Array.isArray(selectedPatientData?.attendants) &&
    selectedPatientData?.attendants?.length > 0
  ) {
  } else {
    toSetSelectedPatientData['attendants'] = [
      {
        name: '',
        primary: true,
        type: 'relative',
      },
    ]
  }
  if (!selectedPatientData?.communicationsToAttendant) {
    toSetSelectedPatientData['communicationToAttendant'] = false
  }
  return { ...toSetSelectedPatientData }
}

export function buildRelatedPatientData(primaryPatient, alreadySelectedData, clinicBrandData) {
  const existingPatientHere = { ...primaryPatient }
  return {
    ...alreadySelectedData,
    defaultCommunicationLanguage: clinicBrandData?.defaultCommunicationLanguage || 'hi',
    mobile: primaryPatient?.mobile,
    email: primaryPatient?.email,
    dependentRelation: 'relative',
    relatedToExistingPatient: existingPatientHere,
  }
}

export function isValidPatientInfoForCreation(patientObject, makeAnonymousPatient) {
  if (!patientObject?.name) {
    console.log('name is not valid')
    return false
  }
  if (!patientObject?.age) {
    console.log('age is not valid')
    return false
  }
  if (!patientObject?.gender) {
    console.log('gender not valid')
    return false
  }
  if (!isPatientMobileValid(patientObject, makeAnonymousPatient)) {
    console.log('mobile not valid')
    return false
  }
  if (!isPatientEmailValid(patientObject, makeAnonymousPatient)) {
    console.log('email not valid')
    return false
  }
  return true
}

export function isPatientEmailValid(patientObject, makeAnonymousPatient) {
  if (!makeAnonymousPatient) {
    // If email is provided but not valid, return false
    if (patientObject?.email && !isValidEmail(patientObject?.email)) {
      return false
    }

    // If email or mobile is valid, return true
    if (
      isValidEmail(patientObject?.email) ||
      isValidMobile(`+${removePlusFromBeginning(patientObject?.mobile)}`)
    ) {
      return true
    }

    // If neither email nor mobile is valid, return false
    return false
  }

  // If makeAnonymousPatient is true, email validation is not required
  return true
}

export function isPatientMobileValid(patientObject, makeAnonymousPatient) {
  if (!makeAnonymousPatient) {
    // If mobile is provided but not valid, return false
    if (
      patientObject?.mobile &&
      !isValidMobile(`+${removePlusFromBeginning(patientObject?.mobile)}`)
    ) {
      return false
    }

    // If email or mobile is valid, return true
    if (
      isValidEmail(patientObject?.email) ||
      isValidMobile(`+${removePlusFromBeginning(patientObject?.mobile)}`)
    ) {
      return true
    }

    // If neither email nor mobile is valid, return false
    return false
  }

  // If makeAnonymousPatient is true, mobile validation is not required
  return true
}
